module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "msg"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "100px auto",
      "width": "70%",
      "border": "1px solid #e6e6e6",
      "padding": "19px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticStyle: {
      "padding": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%",
      "height": "auto",
      "padding-left": "18px"
    }
  }, [_vm._v("学英语并无捷径和秘诀可寻。但是经验告诉我们，总有些技巧和方法可以对学习有些帮助。下面所述这些方法，都是实际可行的，并不是空谈和理论，大家依自己的需要可以选择几项去试一试。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "text-align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "red",
      "border": "1px solid #8c8c8c",
      "-webkit-border-radius": "3px",
      "-moz-border-radius": "3px",
      "border-radius": "3px"
    },
    on: {
      "click": _vm.subHandle
    }
  }, [_vm._v("¥2订阅")])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%",
      "height": "auto",
      "padding-left": "18px"
    }
  }, [_vm._v("英语口语好，到底有多重要？口语学习中，我们都太重视说而忽略了听，这样也就很难发现自己口语的缺陷究竟在哪里。十个妙教你用最简单的方法，学最流利的英语口语，快速天掌握基本对话。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "text-align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "red",
      "border": "1px solid #8c8c8c",
      "-webkit-border-radius": "3px",
      "-moz-border-radius": "3px",
      "border-radius": "3px"
    },
    on: {
      "click": _vm.subHandle
    }
  }, [_vm._v("¥2订阅")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%",
      "height": "auto",
      "padding-left": "18px"
    }
  }, [_vm._v("高考提分秘籍来了，最后冲刺还能再提5分！相信高考临近的这个时候，每一位奋战在高考前线的同学都进入“两耳不闻窗外事，一心只做冲刺卷”的状态。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "text-align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "red",
      "border": "1px solid #8c8c8c",
      "-webkit-border-radius": "3px",
      "-moz-border-radius": "3px",
      "border-radius": "3px"
    },
    on: {
      "click": _vm.subHandle
    }
  }, [_vm._v("¥2订阅")])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "4rem"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "86%",
      "height": "auto",
      "padding-left": "18px"
    }
  }, [_vm._v("提起英文阅读理解，很多同学是一把“辛酸泪”，生词多，读不懂；即使单词都认识，却常常还是读不懂。一旦读不懂，就会影响做题的时间和质量，高中英语考试中阅读理解的九大题型和解题技巧，帮助你提高做题的正确率。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "10%",
      "text-align": "center"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "red",
      "border": "1px solid #8c8c8c",
      "-webkit-border-radius": "3px",
      "-moz-border-radius": "3px",
      "border-radius": "3px"
    },
    on: {
      "click": _vm.subHandle
    }
  }, [_vm._v("¥2订阅")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dialogShow),
      expression: "dialogShow"
    }],
    staticClass: "dialog"
  }, [_c('div', {
    staticStyle: {
      "background-color": "#f3f3f3",
      "border-bottom": "solid 1px #eee",
      "margin": "0",
      "z-index": "auto"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "inline-block",
      "height": "20px",
      "padding": "10px 20px",
      "border": "none 0"
    }
  }, [_vm._v("请扫描支付")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Verdana",
      "font-size": "14px",
      "line-height": "20px",
      "color": "#999",
      "text-align": "center",
      "display": "inline-block",
      "width": "20px",
      "height": "20px",
      "position": "absolute",
      "z-index": "1",
      "top": "10px",
      "right": "10px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-bottom": "1px solid #e6e6e6",
      "padding-bottom": "15px",
      "margin-bottom": "15px"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  }, [_vm._v("有偿资讯")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "line-height": "20px",
      "display": "block",
      "height": "20px",
      "padding": "5px 0"
    }
  }, [_c('i', {
    staticStyle: {
      "background-color": "#666",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "3px",
      "height": "3px",
      "margin-right": "10px"
    }
  }), _vm._v(" "), _c('b', [_vm._v("怎么学英语")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#aaa",
      "float": "right"
    }
  }, [_vm._v("2020-03-25 14:53")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "line-height": "20px",
      "display": "block",
      "height": "20px",
      "padding": "5px 0"
    }
  }, [_c('i', {
    staticStyle: {
      "background-color": "#666",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "3px",
      "height": "3px",
      "margin-right": "10px"
    }
  }), _vm._v(" "), _c('b', [_vm._v("十个妙招教你快速练就好口语")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#aaa",
      "float": "right"
    }
  }, [_vm._v("2019-09-01 09:13")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "line-height": "20px",
      "display": "block",
      "height": "20px",
      "padding": "5px 0"
    }
  }, [_c('i', {
    staticStyle: {
      "background-color": "#666",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "3px",
      "height": "3px",
      "margin-right": "10px"
    }
  }), _vm._v(" "), _c('b', [_vm._v("高考英语提分秘籍来了！")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#aaa",
      "float": "right"
    }
  }, [_vm._v("2019-06-23 15:09")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticStyle: {
      "line-height": "20px",
      "display": "block",
      "height": "20px",
      "padding": "5px 0"
    }
  }, [_c('i', {
    staticStyle: {
      "background-color": "#666",
      "vertical-align": "middle",
      "display": "inline-block",
      "width": "3px",
      "height": "3px",
      "margin-right": "10px"
    }
  }), _vm._v(" "), _c('b', [_vm._v("高中英语阅读理解解题技巧，教你一眼看出正确答案")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "#aaa",
      "float": "right"
    }
  }, [_vm._v("2019-05-05 10:03")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "342.4px",
      "height": "465.6px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": require("../assets/images/qrcode.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9d40452","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Messages.vue
// module id = 101
// module chunks = 0